import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {StateSnackBarService} from "../services/state-snack-bar.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBarService = inject(StateSnackBarService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401) {
        let errorMessage;
        if (error.error && typeof error.error.message === 'string') {
          errorMessage = error.error.message;
        } else {
          errorMessage = error.message;
        }
        snackBarService.error({subMessage: errorMessage, message: error.status.toString() ?? "No Code"});
      }

      return throwError(() => error);
    })
  );
};
